define(
    'chartApi/index',['lodash', 'jquery', 'moment', 'es6-promise', 'knockout', 'dataSource/timeData', 'dataSource/userPreferences',
        'atn/atn', 'dataSource/analytics/analyticsRegistry', './filters', './exportingApi'
    ],
    function(_, $, moment, es6Promise, ko, timeData, userPreferences, atn, analyticsRegistry, filters, exportingApi) {

        if (!window.Promise) {
            window.Promise = es6Promise.Promise;
        }

        delete window.moment;

        // TODO move it to config
        var basePath = '../../';

        var matrixCharts = window.matrixCharts;

        window.matrixCharts.init(
            _,
            apiRequest, {},
            moment,
            'enUS',
            basePath,
            matrixCharts.constants.BROWSER, {
                log: _.noop
            }
        );

        return {
            createChartComponent: createChartComponent,
            matrixCharts: matrixCharts
        };

        function createChartComponent(chartId, userPrefs) {
            var chartConfig = _.find(matrixCharts.charts, {
                chartId: chartId
            });
            var modelData = {};

            var dateInterval = ko.observable(null);

            var totalValueGraphCount = ko.observable(null);

            var dataAvailabilityCounter = ko.observable(0);

            var dateGeneratedOn = ko.computed(computeDateGeneratedOn);

            var isLoading = ko.observable(false);

            var errorObservable = ko.observable({});

            var apiFailure = ko.observable(false);

            var uiFilters = _.map(chartConfig.filters, function(filterConfig){
                return filters.createFilter(filterConfig, userPrefs[chartId] ? userPrefs[chartId].filter : null, chartConfig.additionalFilterConfig);
            });

            analyticsRegistry.push(isLoading);

            _.forEach(uiFilters, function(filter) {
                if (filter.onChange) {
                    filter.onChange(start);
                    filter.onChange(setChartView);
                    filter.onChange(updateChartUserPreferences);
                }
            });

            var chartOptions = {
                model: {
                    modelData: modelData,
                    dataAvailabilityCounter: dataAvailabilityCounter,
                    errorObservable: errorObservable,
                    isLoading: isLoading,
                    apiFailure: apiFailure
                },
                template: chartConfig.chartTemplate
            };
            /**variables and config for the html table view and csv chart downloads**/
            var chartViewStateEnum = {
                'TABLE': 'table',
                'GRAPH': 'graph'
            };

            var chartViewConfig = {
                viewState: ko.observable(chartViewStateEnum.GRAPH),
                viewStateEnum: chartViewStateEnum,
                chartContainer: ko.observable(),
                htmlTable: ko.observable(),
                startFlip: ko.observable(false)
            };

            return {
                chartConfig: chartConfig,
                chartOptions: chartOptions,
                totalValueGraphCount: totalValueGraphCount,
                filters: uiFilters,
                timeBoundary: timeData.timeBoundary,
                labelsAndStrings: chartConfig.i18n,
                globalMessages: atn.config.messages.graphs,
                start: start,
                dateGeneratedOn: dateGeneratedOn,
                showDataAvailability: (
                    _.indexOf(['TREND', 'TOP_N'], chartConfig.chartType) < 0
                ),
                chartViewConfig: chartViewConfig,
                browserName: atn.utils.getBrowserName,
                viewToggleFn: viewToggleFn,
                dateInterval: dateInterval
            };

            /**
             * Start a new processing of the chart viewmodel and data model.
             * @return {undefined}
             */
            function start() {
                var intervalFilter = _.find(uiFilters, {id: 'interval'});

                if(intervalFilter){
                    intervalFilter.initializeRanges();
                }
               
               
                var filters = _.map(uiFilters, function(filter) {
                    return {
                        id: filter.id,
                        value: filter.value
                    };
                });

                var chartContext = {
                    baseTime: timeData.timeBoundary(),
                    filter: filters
                };

                if (!isLoading.peek()) {
                    isLoading(true);
                    errorObservable({});
                    matrixCharts.startFlow(chartConfig, chartContext, onChartsCreationSuccess, onChartCreationFailure);
                }
            }


            /**
             * @param  {the context in which th chart was created}
             * @return {undefined}
             */
            function onChartsCreationSuccess(context) {
                apiFailure(false);
                dataAvailabilityCounter(context.dataAvailabilityCounter);
                totalValueGraphCount(context.totalValueGraphCount);
                _.assign(modelData, context.modelData);
                _.forEach(uiFilters, function(filter) {
                    if (filter.postFlowActions) {
                        _.defer(filter.postFlowActions, context);
                    }
                });
                dateInterval(context.intervals[0][0]);
                setLoadingFalse();
            }

            /**
             * @param  {Object the error object}
             * @return {undefined}
             */
            function onChartCreationFailure(err) {
                errorObservable(err);
                apiFailure(!!err.apiFailure);
                setLoadingFalse();
                console.error(chartConfig.chartId, err);
            }

            /**
             * Marke the completion of the chart generation.
             */
            function setLoadingFalse() {
                _.delay(isLoading, 200, false);
            }

            function setChartView() {
                chartViewConfig.viewState(chartViewConfig.viewStateEnum.GRAPH);
                chartViewConfig.startFlip(false);
            }


            function updateChartUserPreferences() {
                var keyStr = '',
                    valueObj = {},
                    prefsData = [];
                _.forEach(uiFilters, function(filter) {

                    if (_.indexOf(['date', 'duration'], filter.id) !== -1) {
                       
                        keyStr = [userPreferences.allUserPreferences()[userPreferences.ACTIVE_DASHBOARD], chartId].join('.');

                        valueObj.filter = {};
                        valueObj.filter.id = filter.id;
                        valueObj.filter.value = filter.selectedChoice();

                        if (filter.selectedChoice() === 'custom') {
                            valueObj.filter.customStartDate = moment(filter.value.customStartDate).format(atn.config.dateFormatStringStandard);
                            valueObj.filter.customEndDate = moment(filter.value.customEndDate).format(atn.config.dateFormatStringStandard);
                            if(filter.value.customPointInTime){
                                valueObj.filter.customPointInTime = moment(filter.value.customPointInTime).format(atn.config.dateFormatStringStandard);
                            }
                        }

                        prefsData.push({
                            keyString: keyStr,
                            valueString: JSON.stringify(valueObj)
                        });
                    }
                });
               
                _.forEach(prefsData,function(preference){
                    userPreferences.updateUserPreferences(preference);
                });
            }

            /**
             * Function to handle the toggling of the chart view.
             * @return {undefined}
             */
            function viewToggleFn() {

                if (chartViewConfig.viewState() === chartViewConfig.viewStateEnum.TABLE) {
                    chartViewConfig.viewState(chartViewConfig.viewStateEnum.GRAPH);
                } else {
                    chartViewConfig.viewState(chartViewConfig.viewStateEnum.TABLE);
                    var innerHtmlString = exportingApi.htmlFromHighcharts(chartViewConfig.chartContainer());
                    chartViewConfig.htmlTable().innerHTML = innerHtmlString;
                }

                chartViewConfig.startFlip() ?
                    _.delay(chartViewConfig.startFlip, 200, false) :
                    _.delay(chartViewConfig.startFlip, 200, true);

            }

            /**
             * Function to compute the data generation date.
             * @return {the data generation date as a string}
             */
            function computeDateGeneratedOn() {
                return moment(timeData.timeBoundary()).format(atn.config.dayGeneratedOnFormat);
            }
        }

        function apiRequest(options) {
            return $.ajax(options);
        }
    });

